import { useContext } from "react";
import { AuthContext } from "../context";
import { decodeCookie } from "../utils/decodeCookie";
import { logOut } from "../utils/decodeCookie";

export const useAuth = () => {
  const {
    token,
    setToken,
    setCurrentUser,
    currentUser,
    webSettings,
    setWebSettings,
  } = useContext(AuthContext);

  const deleteCookie = () => {
    logOut()
  };

  const userLogin = () => {
    const token = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
    ).slice(1);
    const userData = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
    )
      ? JSON?.parse(
        decodeCookie(
          process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_USER_DATA
        ).slice(1)
      )
      : "";

    setToken(token);
    setCurrentUser(userData);
  };

  return {
    userLogin,
    deleteCookie,
    token,
    currentUser,
    setToken,
    setCurrentUser,
    webSettings,
    setWebSettings,
  };
};

export default useAuth;
